import { inject, Injectable } from '@angular/core';
import { VIEWER_BASE_URL } from './viewer-base-url.token';
import { UrlFlagsService } from '../url-flags/url-flags.service';

interface ViewerNavigationOptions {
  taskId?: string;
  sceneId?: string;
}

@Injectable({ providedIn: 'root' })
export class ViewerNavigationService {
  private readonly viewerBaseUrl = inject(VIEWER_BASE_URL);
  private readonly urlFlags = inject(UrlFlagsService);

  private getValidModels(models?: { id?: string; latestRevision?: number }[]) {
    return (models ?? []).flatMap(model => {
      if (!model.id) {
        return [];
      }

      return [{ id: model.id, latestRevision: model.latestRevision ?? 1 }];
    });
  }

  openViewer(
    teamId: string,
    projectId: string,
    models?: { id?: string; latestRevision?: number }[],
    options?: ViewerNavigationOptions
  ): void {
    const target = this.createTargetUrl(teamId, projectId, models, options);

    if (this.urlFlags.embedded()) {
      globalThis.open(target, '_blank', 'noopener,noreferrer');
    } else {
      globalThis.location.href = target;
    }
  }

  createTargetUrl(
    teamId: string,
    projectId: string,
    models?: { id?: string; latestRevision?: number }[],
    options?: ViewerNavigationOptions
  ): string {
    const url = new URL(this.viewerBaseUrl);
    url.searchParams.set('team', teamId);
    url.searchParams.set('project', projectId);
    this.getValidModels(models).forEach(model =>
      url.searchParams.append('model', `${model.id},${model.latestRevision}`)
    );
    if (options?.taskId) {
      url.searchParams.set('task', options.taskId);
    }
    if (options?.sceneId) {
      url.searchParams.set('scene', options.sceneId);
    }
    return url.toString();
  }
}
